module.exports = __webpack_public_path__ + "static/story1-ac6a0ac7825b1bde15d03bbd2cf205d4.png";